export const REPORT_ID = 'slide-33';
export const SLIDE_NUMBER = 33;
export const MIN_DATE = 120020101;

export const colors = ['#1CA955', '#E38114', '#DD5C3D', '#8F8F8F', '#D9D10C', '#2D5EDA', '#784FBA', '#D656A3'];